import store from '@Store';
import {
  setInputValueType,
  setIsLoadingType,
  setSelectedMapType,
  addSelectedType,
  clearSearchType,
} from './QuickSearchAutosuggestConstants';
import { inputValue as inputValueSelector, selectedMap as selectedMapSelector } from './QuickSearchAutosuggestSelectors';
import QuickSearchAutosuggestFetcher from './QuickSearchAutosuggestFetcher';
import {
  generateSelectedKey,
  generateSelectedTitle,
  generateSelectedTypeahead,
  generateSelectedAnalytics,
  filterSelectedMapStillInUse,
  getTypeaheadsForSearch,
  getAnalyticsForSearch,
} from './QuickSearchAutosuggestHelper';

export function setInputValue(inputValue) {
  return {
    type: setInputValueType,
    payload: { inputValue },
  };
}

export function setIsLoading(isLoading) {
  return {
    type: setIsLoadingType,
    payload: { isLoading },
  };
}

export function fetchAutosuggestMatches(query) {
  return async (dispatch) => {
    let autosuggestMatches;

    dispatch(setIsLoading(true));

    try {
      autosuggestMatches = await QuickSearchAutosuggestFetcher.getAutosuggestsByQuery(query);
      dispatch(setIsLoading(false));
    } catch (e) {
      dispatch(setIsLoading(false));
    }

    return autosuggestMatches;
  };
}

export function setSelectedMap(selectedMap) {
  return {
    type: setSelectedMapType,
    payload: { selectedMap },
  };
}

export function addSelected({ key, title, Typeahead, analytics } = {}) {
  return {
    type: addSelectedType,
    payload: { key, title, Typeahead, analytics },
  };
}

export function onSelect(selected, metadata) {
  return (dispatch) => {
    const key = generateSelectedKey(selected, metadata);
    const title = generateSelectedTitle(selected);
    const Typeahead = generateSelectedTypeahead(selected, metadata);
    const analytics = generateSelectedAnalytics(selected, metadata);

    return dispatch(addSelected({ key, title, Typeahead, analytics }));
  };
}

export function runSearch() {
  return (dispatch, getState) => {
    const state = getState();

    const inputValue = inputValueSelector(state);
    const selectedMap = selectedMapSelector(state);
    const filteredSelectedMap = filterSelectedMapStillInUse(selectedMap, inputValue);

    dispatch(setSelectedMap(filteredSelectedMap));

    const filteredSelectedObj = filteredSelectedMap.toJS();

    return {
      queryText: inputValue,
      Typeaheads: getTypeaheadsForSearch(filteredSelectedObj),
      analytics: getAnalyticsForSearch(filteredSelectedObj),
    };
  };
}

export function clearSearch() {
  return {
    type: clearSearchType,
  };
}

/* External */

export function dispatchSetInputValue(...args) {
  return store.dispatch(setInputValue(...args));
}

export function dispatchRunSearch() {
  return store.dispatch(runSearch());
}

export function dispatchClearSearch() {
  return store.dispatch(clearSearch());
}
